jQuery( document ).ready( function ($) {
    "use strict";

    if (  $( '[data-media-sample]' ).length ) {

        var audio_player = WaveSurfer.create({
            barWidth: 1.6,
            barHeight: 1,
            barGap: 2,
            container: '#mediaplayer',
            fillParent: true,
            height: 53,
            mediaControls: true,
            progressColor: '#F4C215',
            partialRender: false,
            responsive: true,
            waveColor: '#202020'
        });

        audio_player.load( $( '[data-media-sample]' ).data( 'media-sample' ) );
        audio_player.on( 'ready', function () {
            $( '#mediaprogress' ).html( '00:00' );
            $( '#mediatotal' ).html( getFormattedTime( audio_player.getDuration() ) );
        });

        $( '#mediaplay' ).on( 'click', function (e) {

            e.preventDefault();

            $( '#mediaplay' ).toggleClass( 'is-active' );

            audio_player.playPause();
        });

        // Show current time
        audio_player.on( 'audioprocess', function () {
            $( '#mediaprogress' ).text( getFormattedTime( audio_player.getCurrentTime() ) );
        });

        audio_player.on( 'seek', function () {
            $( '#mediaplay' ).removeClass( 'is-active' );
        });
    }

    function getFormattedTime( seconds ) {

        return [
            Math.floor((seconds % 3600) / 60), // minutes
            ('00' + Math.floor(seconds % 60)).slice(-2) // seconds
        ].join(':');
    }

    $( '#samplesdropdown' ).on( 'click', function(e) {
        e.preventDefault();

        $( '.product-media__additional-list' ).toggleClass( 'is-active' );
    });

    $( '.product-media__additional-link' ).on( 'click', function(e) {
        e.preventDefault();

        if ( $( this ).attr( 'href' ) ) {

            audio_player.load( $( this ).attr( 'href' ) );
            $( '#downloadbutton' ).attr( 'href', $( this ).attr( 'href' ) );

            if ( $( this ).find( $( '[data-sample-label]' ) ).length ) {
                $( '#medianame' ).text( $( this ).find( $('[data-sample-label]') ).text() );
            }

            audio_player.on( 'ready', function() {
                audio_player.play();
                $( '.product-media__additional-list' ).removeClass( 'is-active' );
                $( '#mediaplay' ).addClass( 'is-active' );
                $( '#total' ).text( getFormattedTime( audio_player.getDuration() ) );
            });
        }
    });

    $( document ).on( 'click', function(e) {
        if ( ! ( $( e.target ).closest( '#samplesdropdown' ).length ) ) {

            if ( ! ( $( e.target ).closest( '.product-media__additional-list' ).length ) ) {
                $( '.product-media__additional-list' ).removeClass( 'is-active' );
            }
        }
    });

});
